module.exports = __webpack_public_path__ + "static/media/loading.71055614.svg";